import React, { useMemo } from 'react';

const DashboardRecentResults = ({ allGames }) => {
  const recent = useMemo(() => {
    if (!allGames?.length) return [];
    return allGames
      .filter(g => g.status?.abstractGameState === 'Final')
      .slice(-15)
      .reverse()
      .map(g => {
        const bosHome = g.teams?.home?.team?.id === 111;
        const bosScore = Number(bosHome ? g.teams.home.score : g.teams.away.score);
        const oppScore = Number(bosHome ? g.teams.away.score : g.teams.home.score);
        const opp = bosHome ? g.teams.away.team.abbreviation : g.teams.home.team.abbreviation;
        const won = bosScore > oppScore;
        const d = new Date(g.gameDate);
        return { won, bosScore, oppScore, opp, isHome: bosHome, date: `${d.getMonth() + 1}/${d.getDate()}` };
      });
  }, [allGames]);

  if (!recent.length) return null;

  const wins = recent.filter(g => g.won).length;

  return (
    <div className="border border-[#658d71] bg-[rgba(0,0,0,0.08)]">
      <div className="px-3 py-2 border-b border-[#658d71] bg-[rgba(0,0,0,0.1)] flex items-center justify-between">
        <span className="text-xs font-black uppercase tracking-widest text-[#d8ceb3]">Recent Results</span>
        <span className="text-[9px] font-black uppercase tracking-widest text-[#a9c9b1]">
          Last {recent.length} · {wins}W–{recent.length - wins}L
        </span>
      </div>
      <div className="p-3 flex flex-col gap-1.5">
        {recent.map((g, i) => (
          <div key={i} className="flex items-center gap-2 py-1 border-b border-[rgba(101,141,113,0.15)] last:border-0">
            <span className={`text-[9px] font-black uppercase px-1.5 py-0.5 w-6 text-center shrink-0 ${g.won ? 'bg-[rgba(101,141,113,0.4)] text-[#a9c9b1]' : 'bg-[rgba(196,51,62,0.3)] text-[#c4333e]'}`}>
              {g.won ? 'W' : 'L'}
            </span>
            <span className="text-[9px] text-[#658d71] font-bold w-10 shrink-0">{g.date}</span>
            <span className="text-[9px] text-[#a9c9b1] font-bold uppercase w-8 shrink-0">{g.isHome ? 'vs' : '@'} {g.opp}</span>
            <span className={`text-[10px] font-black tabular-nums ml-auto ${g.won ? 'text-[#a9c9b1]' : 'text-[#c4333e]'}`}>
              {g.bosScore}–{g.oppScore}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DashboardRecentResults;